module.exports = __webpack_public_path__ + "static/pokoj-nr1-photo06-bdc6d1b4c48ef66afb3d7ec8fa44071f.jpg";